
const isNumber = /[0-9]/;

class BrandList {

    constructor(el) {
        this.el = el;
        this.el.classList.add('brand-list');
        this.opts = this.getDefaultOptions();
        this.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '#'];
        this.filter = '';
        this.results = [];

        this.load().then(() => this.build(true));
    }

    load() {
        let url = `${this.opts.baseUrl}/api/v1/brands/list`;

        if (this.opts.category) {
            url += `?categoryUrl=${this.opts.category}`;
        }

        return fetch(url)
            .then(response => response.json())
            .then(data => {
                data.brands = data.brands || [];
                data.brands.forEach(brand => {
                    brand.href = `${data.category.url}?filters=brandname%3D${encodeURIComponent(brand.name)}`;
                });
                this.data = data;
                this.el.classList.add('loaded');
            })
            .catch((error) => {
                console.error('Error loading brand list: ', error);
            });
    }

    build(first) {
        if (this.data && this.data.brands.length > 0) {

            if (first) {
                let featured = this.buildFeatured();
                let index = this.buildIndex();
                this.el.innerHTML = featured + index;

                this.resultsEl = this.el.querySelector('.results');
                this.resultGroupEls = [...this.el.querySelectorAll('[data-result-group]')];
                this.searchInput = this.el.querySelector('.search input');
                this.brandIndexEl = this.el.querySelector('.brand-index');
                this.mainHeader = document.querySelector('.sticky_header .main_header');

                this.headerHeight = 105;

                this.searchInput.addEventListener('input', (e) => {
                    clearTimeout(this.searchInputTimeout);
                    this.searchInputTimeout = setTimeout(() => {
                        this.searchTerms = (e.target.value || '').toLowerCase().trim().replace(/\s+/g, ' ').split(' ').filter(x => !!x);
                        this.updateResults();
                        this.ensureWithinViewport();
                    }, 150);
                });

                this.searchInput.addEventListener('keypress', (e) => {
                    if ((e.key && e.key.toLowerCase() === 'enter') || (e.code && e.code.toLowerCase() === 'enter')) {
                        e.preventDefault();
                    }
                });

                this.el.addEventListener('click', (e) => {
                    let el = e.target.closest('[data-result-group]');
                    if (el) {
                        this.gotoGroup(el.dataset.resultGroup);
                    }
                }, true);

                if (this.mainHeader) {

                    this.headerHeight = this.mainHeader.getBoundingClientRect().height;

                    if ('ResizeObserver' in window) {
                        // create the observer
                        let resizeObserver = new ResizeObserver((entries) => {
                            clearTimeout(this.headerHeightTimeout);
                            this.headerHeightTimeout = setTimeout(() => {
                                if (Math.abs(entries[0].contentRect.height - this.headerHeight) > 5) {
                                    this.headerHeight = entries[0].contentRect.height;
                                    this.setupGroupObserver();
                                }
                            }, 100);
                        });
                        resizeObserver.observe(this.mainHeader);
                    }
                }
            }

            this.updateResults();
        }
    }

    buildFeatured() {
        let featuredBrands = this.data.brands.filter(x => x.isFeatured);

        if (featuredBrands.length === 0) {
            return "";
        }

        let maxCols = 4;
        let gridClass = "25";

        if (featuredBrands.length < 4 || featuredBrands.length % 3 === 0) {
            maxCols = 3;
            gridClass = "33"
        }

        let items = featuredBrands.map(brand => {
            let image = !!brand.image ? `<img src="${brand.image}" alt="${brand.displayName}">` : `<span class="text text-upper center-content">${brand.displayName}</span>`;
            return `<div class="col flex-col-100 flex-col-sm-50 flex-col-md-${gridClass}">
                <a href="${brand.href}" class="item">
                    <div class="image">${image}</div>
                    <span class="link text-upper text-center">Shop Now</span>
                </a>
            </div>`;
        }).join('');

        return `<div class="featured-brands cols-${maxCols}">
            <h2 class="title text-center">Featured Brands</h2>
            <div class="flex-row items center-content">${items}</div>
        </div>`;
    }

    buildIndex() {

        let letterNavItems = this.alphabet.map(letter => `<li data-result-group="${letter}"><a>${letter}</a></li>`).join('');

        return `<div class="brand-index">
            <header>
                <div class="search">
                    <input type="search" placeholder="Find a brand">
                </div>
                <nav>
                    <ul>${letterNavItems}</ul>
                </nav>
            </header>
            <div class="results"></div>
        </div>`
    }

    gotoGroup(groupName) {
        let groupMarker = this.el.querySelector(`[data-group-marker="${groupName}"]`);
        if (groupMarker) {
            this.setActiveGroup(groupName, true);
            groupMarker.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }

    updateResults() {
        if (this.groupObserver) {
            this.groupObserver.disconnect();
            this.groupObserver = null;
        }

        this.results = this.groupByLetter(this.getFilteredBrands());
        this.resultsEl.innerHTML = this.getResultsHtml();

        this.resultGroupEls.forEach(el => {
            let className = 'has-results';
            let groupName = el.dataset.resultGroup;
            let group = this.results.find(x => x.name === groupName);

            if (!group || group.items.length === 0) {
                className = 'empty';
            }

            el.setAttribute('class', className);
        });

        this.groupEls = [...this.resultsEl.querySelectorAll('[data-group]')];

        this.setupGroupObserver();
    }

    ensureWithinViewport() {
        let clientRect = this.brandIndexEl.getBoundingClientRect();
        if (clientRect.bottom < 0) {
            this.brandIndexEl.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }

    setupGroupObserver() {
        if (this.groupObserver) {
            this.groupObserver.disconnect();
            this.groupObserver = null;
        }

        if (!this.groupEls || this.groupEls.length === 0) {
            return;
        }

        this.groupObserver = new IntersectionObserver(entries => {

            entries.forEach(entry => {
                entry.target.isIntersecting = entry.isIntersecting;
            });

            let activeGroups = this.groupEls.filter(x => x.isIntersecting);

            if (activeGroups.length > 0) {
                this.setActiveGroup(activeGroups[0].dataset.group);
            } else {
                this.setActiveGroup('');
            }

        }, { scrollMargin: '-' + (Math.ceil(this.headerHeight) + 45) + 'px 0px 0px 0px', threshold: 0.5 });

        this.groupEls.forEach(group => {
            this.groupObserver.observe(group);
        });
    }

    getFilteredBrands() {
        
        if (!this.searchTerms || this.searchTerms.length === 0) {
            return this.data.brands.map(x => {
                x.ranges = null;
                return x;
            });
        }

        return this.data.brands.filter(x => {
            let brandName = (x.displayName || x.name || '').toLowerCase();
            let isMatch = false;
            x.ranges = [];
            this.searchTerms.forEach(term => {
                let index = brandName.indexOf(term);
                if (index > -1) {
                    isMatch = true;
                    x.ranges.push({ from: index, to: index + term.length });
                }
            });
            return isMatch;
        });
    }

    setActiveGroup(groupName, force) {

        clearTimeout(this.activeGroupTimeout);

        this.activeGroupTimeout = setTimeout(() => {
            if (this.activeGroup === groupName) {
                return;
            }
            this.activeGroup = groupName;

            this.resultGroupEls.forEach(el => {
                el.classList.toggle('active', el.dataset.resultGroup === groupName);
            });
        }, force === true ? 0 : 100);
    }

    getResultsHtml() {

        if (!this.results || this.results.length === 0) {
            let detail = '';
            if (!!this.searchTerms && this.searchTerms.length > 0) {
                let search = this.searchTerms.join(" ");
                detail = ` for "${search}"`;
            }
            return `<div class="no-results">Sorry, we couldn't find any results${detail}</div>`
        }

        let output = this.results.map(group => {

            let groupItems = group.items.map(item => {
                let displayName = '';

                if (item.ranges && item.ranges.length > 0) {
                    let currentRange = 0;
                    for (var i = 0; i <= item.displayName.length; i++) {
                        if (currentRange < item.ranges.length) {
                            if (i === item.ranges[currentRange].from) {
                                displayName += '<b>';
                            } else if (i === item.ranges[currentRange].to) {
                                displayName += '</b>';
                                currentRange++;
                            }
                        }
                        if (i < item.displayName.length) {
                            displayName += item.displayName.charAt(i);
                        }
                    }
                } else {
                    displayName = item.displayName;
                }

                return `<div class="flex-col-100 flex-col-sm-50 flex-col-md-25">
                    <a href="${item.href}">${displayName}</a>
                </div>`;
            }).join('');

            return `<div class="group" data-group="${group.name}">
                <div class="group-marker" data-group-marker="${group.name}"></div>
                <h3 class="title">${group.name}</h3>
                <div class="flex-row items">
                    ${groupItems}
                </div>
            </div>`;

        }).join('');

        return output;
    }

    getResultsGroup(letter) {
        return isNumber.test(letter) ? '#' : letter.toUpperCase();
    }

    groupByLetter(brands) {

        let output = [];
        let groups = {};

        if (!brands || brands.length === 0) {
            return output;
        }

        brands.sort((a, b) => isNumber.test(a.slug[0]) - isNumber.test(b.slug[0]) || a.slug.localeCompare(b.slug, undefined, { numeric: true, sensitivity: 'base' }));

        brands.forEach(brand => {

            let group = this.getResultsGroup(brand.displayName.charAt(0));

            if (!groups[group]) {
                groups[group] = {
                    name: group,
                    items: []
                };
                output.push(groups[group]);
            }

            groups[group].items.push(brand);
        });

        return output;
    }

    getDefaultOptions() {
        let scriptUrl = new URL(document.currentScript.src);
        return { baseUrl: scriptUrl.origin, ...this.el.dataset };
    }
}

BrandList.init = function() {
    [...document.querySelectorAll('[data-brand-list]')].forEach((el) => {
        el.brandList = el.brandList || new BrandList(el);
    });
}

BrandList.init();